import { render, staticRenderFns } from "./webshop-confirmation.vue?vue&type=template&id=37609025&scoped=true&"
import script from "./webshop-confirmation.vue?vue&type=script&lang=js&"
export * from "./webshop-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./webshop-confirmation.vue?vue&type=style&index=0&id=37609025&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37609025",
  null
  
)

export default component.exports